import React from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as SVGArrowRight } from 'assets/icons/vectorArrowRight.svg';
import { ReactComponent as SVGArrowLeft } from 'assets/icons/vectorArrowLeft.svg';
import { Typography } from '@deeptrue-frontend/ui';

const MainTitle = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 600;
`;

const SubTitle = styled(Typography)`
  font-size: 0.75rem;
`;
const LegendWrapper = styled.div`
  margin-bottom: 2rem;
  display: flex;
  margin-right: 1.5rem;
`;

interface ArrowProps {
  title?: string;
  subTitle?: string;
  double?: boolean;
}

const ArrowBox = styled.div<{ double?: boolean }>`
  border: 4px solid black;
  position: relative;
  width: 100%;
  border-right: none;
  height: 96px;
  border-radius: ${({ double }) => (double ? '3px' : '0 3px 3px 0;')};
  border-left: ${({ double }) => (double ? 'none' : '4px solid black')};
  margin: ${({ double }) => (double ? '0 0.5rem' : '0 0.5rem 0 0')};
`;

const ArrowRight = styled(SVGArrowRight)`
  position: absolute;
  top: -4px;
  right: -42px;
`;

const TextWrapper = styled.div<{ double?: boolean }>`
  padding: ${({ double }) => (double ? '0.5rem 0 0 3rem ' : '0.5rem 0 0 1rem')};
`;

const ArrowLeft = styled(SVGArrowLeft)<{ double?: boolean }>`
  position: absolute;
  top: -4px;
  left: -5px;
  ${({ double }) =>
    !double &&
    `
    visibility: hidden;
    `}
`;

const Arrow = ({ title, subTitle, double = false }: ArrowProps) => (
  <ArrowBox double={double}>
    <TextWrapper double={double}>
      <MainTitle>{title}</MainTitle>
      <SubTitle>{subTitle}</SubTitle>
    </TextWrapper>
    <ArrowLeft double={double} />
    <ArrowRight />
  </ArrowBox>
);

interface LegendItemType {
  title: string;
  subtitle: string;
}

interface Props {
  legend: Array<LegendItemType>;
}

const Legend = ({ legend }: Props) => {
  return (
    <LegendWrapper>
      {legend.map((legendItem: LegendItemType, index: number) => (
        <Arrow
          key={legendItem.title}
          double={index !== 0}
          title={legendItem.title}
          subTitle={legendItem.subtitle}
        />
      ))}
    </LegendWrapper>
  );
};

export default Legend;
